

























































































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import ChangeRadio from '@/components/changeRadio/changeRadio.vue';
import { institutionServer } from '@/api/installServer';

@Component({
  components: { ChangeRadio },
})
export default class Tree extends Vue {
  private visible = false;
  private isVisible = true;
  private input: any = '';
  private showList: any = true;
  private showText: any = false;
  private checkedText: any = [];
  private checkedInnerText: any = [];
  private checkedRoleText: any = [];
  private dataList: any = []; // 暂时代替传入的数据
  private isCheckedId: any = '';

  private cities: any = []; // 展示可选的数据

  // // 角色列表
  // private roleList: any = []; // 展示可选的数据

  private innerCities: any = []; // 展示可选的数据

  // private workType: any = [
  //   {
  //     name: '组织架构',
  //     type: 0,
  //   },
  //   {
  //     name: '角色列表',
  //     type: 1,
  //   },
  // ];

  private arr: any = [];

  private created() {
    // this.getList();
  }

  private mounted() {}

  private getList(val?: any) {
    institutionServer
      .getAllDeptStaff({
        name: val ? val : null,
      })
      .then((res: any) => {
        this.cities = res.data.deptList;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * 打开窗口
   */
  private async showDialog(data: any) {
    this.dataList = data;
    this.getList();
    const a: any = [];
    setTimeout(() => {
      this.dataList.map((res: any) => {
        this.cities.map((re: any) => {
          if (res.objId === re.id) {
            (this.$refs.multipleTable as any).toggleRowSelection(re, true);
          }
        });
        a.push({
          staffId: res.objId,
          staffName: res.objName,
        });
      });
      this.selectionRowAll(a, undefined);
    }, 100);
    this.visible = true;
  }

  selectionRow(selection: any, row?: any) {
    const selected = selection.length && selection.indexOf(row) !== -1; //为true时选中，为 0 时（false）未选中
    if (selected) {
      this.cities.map((res: any) => {
        res.staffList.map((r: any) => {
          selection.map((re: any) => {
            if (r.staffId === re.staffId) {
              this.arr.push({
                res,
                re,
              });
            }
          });
        });
      });
      this.checkedInnerText = this.unique(this.arr); // 对存储的数组去重后赋值给列表
    } else {
      this.checkedInnerText.forEach((re: any, index: any) => {
        if (row.staffId === re.re.staffId) {
          this.checkedInnerText.splice(index, 1);
        }
      });
    }
  }

  @Watch('checkedInnerText')
  private test(val: any) {
    const arrStroge: any = this.unique(val);
    this.checkedInnerText = arrStroge;
  }

  //表格全选事件
  selectionRowAll(selection: any, row: any) {
    const selected: any = selection.length && selection.indexOf(row) !== -1; //为true时选中，为 0 时（false）未选中
    if (!selected) {
      this.cities.map((res: any) => {
        res.staffList.map((r: any) => {
          selection.map((re: any) => {
            if (r.staffId === re.staffId) {
              this.arr.push({
                res,
                re,
              });
            }
          });
        });
      });
      this.checkedInnerText = this.unique(this.arr); // 对存储的数组去重后赋值给列表
    }
    if (selected === 0) {
      this.checkedInnerText.forEach((re: any, index: any) => {
        this.innerCities.forEach((res: any, innerIndex: any) => {
          if (re.re.staffId === res.staffId) {
            for (let i = 0; i < this.innerCities.length; i++) {
              this.checkedInnerText.splice(index, 1);
            }
          }
        });
      });
    }
  }

  /**
     @description: 判断是否可以点击下级
     @author: cxf
     @update: cxf 2021/7/15 9:35
     **/
  private isClick(id: any) {
    const num: any = this.checkedText.findIndex((item: any) => {
      return item.id === id;
    });

    return num === -1 ? false : true;
  }

  /**
   * 关闭窗口
   */
  private hideDialog() {
    this.close();
  }

  /**
   * 【表单】弹窗关闭
   */
  private close() {
    this.showText = false;
    this.visible = false;
    this.isVisible = true;
    this.checkedText = [];
    this.checkedInnerText = [];
    this.checkedRoleText = [];
    this.showList = true;
    this.arr = [];
    this.isCheckedId = '';
    (this.$refs.multipleTable as any).clearSelection();
    (this.$refs.multipleInnerTable as any).clearSelection();
    // (this.$refs.multipleRoleTable as any).clearSelection();
    // (this.$refs.workType as any).responseMethod();
  }

  private save() {
    const ListOne: any = []; // 存储id
    let ListTwo: any = []; // 去重之后的数组
    this.checkedText.map((res: any) => {
      ListOne.push({
        objId: res.id,
        objName: res.name,
        type: 'department',
      });
    });

    this.checkedInnerText.map((re: any) => {
      ListOne.push({
        objId: re.re.staffId,
        objName: re.re.staffName,
        type: 'staff',
      });
    });

    ListTwo = this.uniqueOne(ListOne);
    // console.log(ListTwo)

    // this.dataList = ListTwo;
    this.$emit('getCheckOldNodeData', ListTwo);
    this.hideDialog();
  }

  /**
     @description: 选中的值
     @author: cxf
     @update: cxf 2021/7/12 14:04
     **/
  private handleSelectionChange(val: any) {
    this.checkedText = val;
  }

  /**
     @description: 数组去重
     @author: cxf
     @update: cxf 2021/7/26 16:20
     **/
  public unique(arr: any) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].re.staffId === arr[j].re.staffId || arr[i].re.staffId === undefined || arr[j].re.staffId === undefined) {
          // 第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }

  /**
     @description: 数组去重
     @author: cxf
     @update: cxf 2021/7/26 16:20
     **/
  public uniqueOne(arr: any) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].objId === arr[j].objId || arr[i] === undefined || arr[j] === undefined) {
          // 第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }

  // /**
  //        @description: 下一级选中的值
  //        @author: cxf
  //        @update: cxf 2021/7/12 14:04
  //        **/
  // private handleRoleSelectionChange(val: any) {
  //   this.checkedRoleText = val;
  // }

  // /**
  //        @description: 单选操作
  //        @author: cxf
  //        @update: cxf 2021/7/12 15:11
  //        **/
  // private getCheck(data: any) {
  //   if (data === 0) {
  //     this.showList = true;
  //   }
  //   if (data === 1) {
  //     this.showList = false;
  //   }
  // }

  /**
     @description: 对已选的数据进行删除
     @author: cxf
     @update: cxf 2021/7/12 15:15
     **/
  private indexDelete(arr: any, index: any) {
    arr.splice(index, 1);
    (this.$refs.multipleTable as any).clearSelection();
    if (arr) {
      arr.forEach((row: any) => {
        (this.$refs.multipleTable as any).toggleRowSelection(row);
      });
    } else {
      (this.$refs.multipleTable as any).clearSelection();
    }
    this.$forceUpdate();
  }

  /**
     @description: 对下级已选的数据进行删除
     @author: cxf
     @update: cxf 2021/7/12 15:15
     **/
  private indexInnerDelete(arr: any, index: any) {
    arr.splice(index, 1);
    (this.$refs.multipleInnerTable as any).clearSelection();
    if (arr) {
      arr.forEach((row: any) => {
        (this.$refs.multipleInnerTable as any).toggleRowSelection(row.re);
      });
    } else {
      (this.$refs.multipleInnerTable as any).clearSelection();
    }
    this.$forceUpdate();
  }

  // /**
  //        @description: 对已选的角色数据进行删除
  //        @author: cxf
  //        @update: cxf 2021/7/12 15:15
  //        **/
  // private indexRoleDelete(arr: any, index: any) {
  //   arr.splice(index, 1);
  //   (this.$refs.multipleRoleTable as any).clearSelection();
  //   if (arr) {
  //     arr.forEach((row: any) => {
  //       (this.$refs.multipleRoleTable as any).toggleRowSelection(row);
  //     });
  //   } else {
  //     (this.$refs.multipleRoleTable as any).clearSelection();
  //   }
  //   this.$forceUpdate();
  // }

  private nextList(data: any) {
    this.isCheckedId = data.id;
    setTimeout(() => {
      data.staffList.map((res: any) => {
        this.checkedInnerText.map((re: any) => {
          if (res.staffId === re.re.staffId) {
            (this.$refs.multipleInnerTable as any).toggleRowSelection(re.re, true);
          }
        });
      });
      this.dataList.map((res: any) => {
        this.innerCities.map((re1: any) => {
          if (res.objId === re1.staffId) {
            (this.$refs.multipleInnerTable as any).toggleRowSelection(re1, true);
          }
        });
      });
    }, 100);

    this.showText = true;
    this.innerCities = data.staffList;
    this.isVisible = false;
  }

  @Watch('input')
  private searchDept(val: any) {
    this.getList(val);
  }
}
